import script from "./MysticRoomDoor.vue?vue&type=script&setup=true&lang=js"
export * from "./MysticRoomDoor.vue?vue&type=script&setup=true&lang=js"

import "./MysticRoomDoor.vue?vue&type=style&index=0&id=208b0508&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-208b0508"]])

export default __exports__